import Card from "./Card";
import "./OpenCard.scss";

function OpenCard({ card }) {
    return (
        <div className="open-card-wrapper">
            <div className="open-card-picture"><Card card={card} /></div>
            
            <div className="open-card-description">
                {card.rare === "Limited" ? <div className="open-card-limited-description">
                    <p className="open-card-name">{card.name}</p>
                    <p>🆔 Номер: {card.id}</p>
                    <p>⚜️ Редкость: {card.rare}</p>
                    <p>🏮 Серия: {card.event}</p>
                    <p className="open-card-last">🌍 Выпуск: {card.release}</p>
                </div> :
                <div className="open-card-default-description">
                    <p className="open-card-name">{card.name}</p>
                    <p>🗺️ Вселенная: {card.universe_name}</p>
                    <p>⚜️ Редкость: {card.rare}</p>
                    <p>🗡️ Атака: {card.attack}</p>
                    <p>❤️ Здоровье: {card.health}</p>
                    <p className="open-card-last">💠 Ценность: {card.price}</p>
                </div>}
            </div>
        </div>
    )
}

export default OpenCard;